import { module as BaseModule } from 'modujs';
import Navigation from 'a11y-menu';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const navigation = new Navigation({
			menuId: 'nav-menu-mobile',
			click: true
		});

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => navigation.init());
		} else {
			//navigation.init();
			
		}
	}
}